import Rest from '../Rest';

/**
 * @typedef {CarService}
 */
export default class ProspectService extends Rest {
	/**
	 * @type {String}
	 */
    static resource = '/prospects'
	
	async endProspect(prospect) {

		return await this.post(`/endProspect`, prospect)
					
	}

	async listViabilityProviders(prospect) {
		
		return await this.post(`/listViabilityProviders`, prospect)

		
    }

	async addClick(click) {
		
		return await this.post(`/addClick`, click)

		
    }

	async suggestProvider(name) {
		
		return await this.post(`/suggestProvider`, name)

		
    }

	async unregisterEmail(data) {
        
        try {

            return await this.post(`/unregister`, data)          
			
		} catch (error) {

			console.log(error)

			throw new Error(error)
			
		}
    }
}
